// Domain enums relocated from app model files so process-ai (lib) can consume them.
// GraphQL registerEnumType registrations remain in the app sources.

export enum ExpressionType {
  /**
   * Returns "Activate", "Cancel", "DoNothing", "Stop", "Error", null or a boolean (true means "Activate", false means
   * "Cancel").
   */
  ActivationCondition = "ActivationCondition",
  /** Returns any value; the rule runs when it is truthy. */
  RuleRunCondition = "RuleRunCondition",
  /**
   * Same contract as ActivationCondition; the email is sent on true or "Activate". Any other value fails at runtime,
   * and the email isn't sent.
   */
  EmailCondition = "EmailCondition",
  /** Returns the type of the target property the value is written to. */
  PropertyValue = "PropertyValue",
}

export enum SupportedImmigrationCountry {
  DE = "DE",
  AT = "AT",
  UNKNOWN = "UNKNOWN",
}

export enum ProcessRuleTargetType {
  Candidate = "Candidate",
  State = "State",
  Task = "Task",
}

export enum ProcessRuleTaskTargetType {
  All = "All",
  AllOfPhases = "AllOfPhases",
  AllOfAreas = "AllOfAreas",
  Tasks = "Tasks",
}

export enum ProcessRuleTriggerEvent {
  OnCreate = "OnCreate",
  OnInactive = "OnInactive",
  OnActive = "OnActive",
  OnStarted = "OnStarted",
  OnCancelled = "OnCancelled",
  OnFinished = "OnFinished",
  OnError = "OnError",
  OnStopped = "OnStopped",
}

export enum CandidateStatus {
  New = "New",
  Approved = "Approved",
  ForSelection = "ForSelection",
  Associated = "Associated",
  Matched = "Matched",
  Transferred = "Transferred",
  InRecognition = "InRecognition",
  LabourMigrationFinished = "LabourMigrationFinished",
  Paused = "Paused",
  Inactive = "Inactive",
  Rejected = "Rejected",
  Archived = "Archived",
  DroppedOut = "DroppedOut",
  Unknown = "Unknown",
}

export enum BulkTaskOperationKindEnum {
  Create = "Create",
  Update = "Update",
  Delete = "Delete",
}

export enum ExamModuleType {
  Listening = "Listening",
  Speaking = "Speaking",
  Reading = "Reading",
  Writing = "Writing",
  Oral = "Oral",
  Written = "Written",
}

export enum EducationModuleType {
  LanguageLearning = "LanguageLearning",
}

export enum ProcessEventEnum {
  CandidateChanged = "CandidateChanged",
  CandidateCreated = "CandidateCreated",
  InterviewRequested = "InterviewRequested",
  InterviewCanceled = "InterviewCanceled",
  ApplicationReceived = "ApplicationReceived",
  ApplicationRejected = "ApplicationRejected",
  NegativeFeedback = "NegativeFeedback",
  ProcessCompleted = "ProcessCompleted",
  EmployerChanged = "EmployerChanged",
  TalentPoolRequestReceived = "TalentPoolRequestReceived",
  TalentPoolRequestAccepted = "TalentPoolRequestAccepted",
  TalentPoolRequestRejected = "TalentPoolRequestRejected",
  //ApplicationPutOnHold = "ApplicationPutOnHold",
}

